import { render, staticRenderFns } from "./PatternRecover.vue?vue&type=template&id=4f1ce34e&"
import script from "./PatternRecover.vue?vue&type=script&lang=js&"
export * from "./PatternRecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports